export default "__VITE_ASSET__ddS9YzIr__"